'use strict';
(function () {
  angular.module('pentaApp').factory('playlist.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/playlist');
  }
})();
